import { blue, white } from '../theme/colors';

export const searchBoxesData = [
    {
      title: 'Write an article',
      image: require('../assets/homework.png'),
      id: 'article',
      route: 'articles',
      textColor: blue,
      backgroundColor: '#A4E5EE',
    },
    { title: 'Create an activity', image: require('../assets/draw.png'), id: 'activity', textColor: white, backgroundColor: '#EF5C62' },
    {
      title: 'Add to dictionary',
      image: require('../assets/dictionary.png'),
      id: 'dictionary',
      textColor: '#A4E5EE',
      backgroundColor: '#156081',
    },
]
  